import * as types from './mutation-types'
import {createFormData} from "@/mixins/Helpers";
import {REMOVE_KARAOKE_DISC_JOCKEYS} from "./mutation-types";
/* eslint-disable */

export const createKaraoke = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post('store/karaokes', formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateKaraoke = ({commit}, {id, data}) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`update/${id}/karaokes`, formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadDiscJockeys = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/${id}/karaokes/disc-jockeys`).then((response) => {
            commit(types.LOAD_KARAOKE_DISC_JOCKEYS, {karaokeId: id, discJockeys: response.data.discJockeys})
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadParticipators = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/participators`).then((response) => {
            commit(types.LOAD_PARTICIPATORS, response.data.participators)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createDiscJockey = ({commit}, {id, data}) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`create/karaokes/disc-jockeys`, formSubmit).then((response) => {
           // commit(types.ADD_KARAOKE_DISC_JOCKEYS, {karaokeId: id, discJockey: response.data.discJockey})
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadStatistics = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/karaokes/${id}/statistics`).then((response) => {
            // commit(types.ADD_KARAOKE_DISC_JOCKEYS, {karaokeId: id, discJockey: response.data.discJockey})
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}




export const addDiscJockey = ({commit}, {id, data}) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`add/${id}/karaokes/disc-jockeys`, formSubmit).then((response) => {
           // commit(types.ADD_KARAOKE_DISC_JOCKEYS, {karaokeId: id, discJockey: response.data.discJockey})
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteDiscJockey = ({commit}, {id, data}) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`delete/${id}/karaokes/disc-jockeys`, formSubmit).then((response) => {
            commit(types.REMOVE_KARAOKE_DISC_JOCKEYS, {karaokeId: id, ids: data.participators})
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadKaraokes = ({commit}, {search, page}) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/karaokes?search=${search}&page=${page}`).then((response) => {
            commit(types.LOAD_KARAOKES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadKaraoke = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/${id}/karaoke`).then((response) => {
            commit(types.ADD_KARAOKE, response.data.karaoke)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

